/**
 * Streaming chat klient — fetch + ReadableStream + SSE parser.
 * Volá POST /api/chat/stream a invokuje callbacky pro každý chunk.
 *
 * Helper použitý v ChatPage i ChatBubble (DRY).
 */
export async function streamChat({ message, sessionId, onChunk, onDone, onError }) {
  const token = localStorage.getItem('ct-token');
  const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
  let response;
  try {
    response = await fetch(`${baseUrl}/api/chat/stream`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ message, sessionId }),
    });
  } catch (err) {
    onError?.(err.message || 'Stream connection failed');
    return;
  }

  if (!response.ok || !response.body) {
    onError?.(`HTTP ${response.status}`);
    return;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  const handleLine = (raw) => {
    if (!raw.startsWith('data: ')) return;
    try {
      const data = JSON.parse(raw.slice(6));
      if (data.chunk) onChunk?.(data.chunk);
      else if (data.error) onError?.(data.error);
      else if (data.done) onDone?.();
    } catch {
      // partial / malformed chunk — ignore
    }
  };

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';
      for (const raw of lines) handleLine(raw);
    }
    if (buffer) handleLine(buffer);
  } catch (err) {
    onError?.(err.message || 'Stream read failed');
  }
}
